import cardCampo from "../assets/Entradas/Campo.png";
import cardPlateas from "../assets/Entradas/plateas.png";
import cardCampoMobile from "../assets/Entradas/Horizontales/Campo_cel.png";
import cardPlateasMobile from "../assets/Entradas/Horizontales/Platea_cel.png";
import cardPlateaVR from "../assets/Entradas/PlateaVR/platea_visionR.png";
import cardPlateaVRMobile from "../assets/Entradas/PlateaVR/Platea_visionR_cel.png";
import titAccesoGeneral from "../assets/Entradas/tit_acceso_general.png";
import generalFrase from "../assets/Entradas/general_frase.png";
import plateaFrase from "../assets/Entradas/platea_frase.png";
import titPlateaAltaNorte from "../assets/Entradas/Plateas/platea_alta_norte.png";
import titPlateaAltaOeste from "../assets/Entradas/Plateas/platea_alta_oeste.png";
import titPlateaBajaSur from "../assets/Entradas/Plateas/platea_baj_sur.png";
import titPlateaBajaSurA from "../assets/Entradas/Plateas/platea_baj_sur_a.png";
import titVrPlateaAltaNorte from "../assets/Entradas/PlateaVR/platea_norte_vr.png";
import titVrPlateaBajaSur from "../assets/Entradas/PlateaVR/platea_sur_vr.png";
import leyendaTop from "../assets/Entradas/PlateaVR/leyenda_top.png";
import todoResuelto from "../assets/Entradas/todo listo.png";
import price25mil from "../assets/Entradas/Precios/25mil.png";
import price35mil from "../assets/Entradas/Precios/35mil.png";
import price50mil from "../assets/Entradas/Precios/50mil.png";
import price60mil from "../assets/Entradas/Precios/60mil.png";
import price60milLote2 from "../assets/Entradas/Precios/lote2_60mil.png";
import price80milLote2 from "../assets/Entradas/Precios/lote2_80mil.png";
import lote1 from "../assets/Entradas/Precios/Lote1_ultimos_disponibles.png";
/**
 * "Pasale el dato a tu banda" abre el WhatsApp propio de quien lo comparte
 * (sin número de destino fijo), para que elija a quién mandárselo — no un
 * chat hacia el número de TERA.
 */
function wsLinkFor(entradaName) {
  const url = `${window.location.origin}/`;
  const message = `Che, comprate la entrada ${entradaName} que yo ya la compré. ${url}`;
  return `https://api.whatsapp.com/send?text=${encodeURIComponent(message)}`;
}

export const TIERS = [
  {
    key: "pulso",
    name: "PULSO",
    subtitle: "ACCESO GENERAL",
    entradaId: "EntradaGeneral",
    color: "var(--tera-blue)",
    tagColor: "var(--tera-pink)",
    tagShape: "blob",
    cardImageDesktop: cardCampo,
    debajoTitle: lote1,
    cardImageMobile: cardCampoMobile,
    titleImage: titAccesoGeneral,
    shareHeaderImage: generalFrase,
    headline: "ENTRÁ EN LA ENERGÍA DE TERA.",
    bullets: [
      "Sector de pie, sin asientos",
      "Cercanía al escenario",
      "Acceso a barras y gastronmía general",
      "Sanitarios generales",
    ],
    buyLink:
      "https://paseshow.com.ar/eventos/tera-un-millon-de-momentos-la-konga",
    buyLabel: "Pulso",
    wsLink: wsLinkFor("Campo General"),
    priceImage: price50mil,
  },
  {
    key: "orbita",
    name: "ÓRBITA",
    subtitle: "SECTOR PREFERENCIAL",
    entradaId: "EntradaTribuna",
    color: "var(--tera-mint)",
    tagColor: "#fff",
    tagShape: "circle",
    cardImageDesktop: cardPlateas,
    cardImageMobile: cardPlateasMobile,
    taglineImage: plateaFrase,
    headline: "MÁS CERCA DE TODO LO QUE PASA.",
    bullets: [
      "Ingreso por acceso diferenciado",
      "Ubicación preferencial con mejor cercanía al escenario",
      "Barras preferenciales",
      "Baños preferenciales",
      "Acceso a la propuesta gastronómica",
    ],
    tagline: "Más cerca de la música. Más cerca de la energía.",
    description: "Otra perspectiva, la misma noche llevada a otra escala.",
    legendLines: [
      {
        text: "Sector con asientos no numerados.",
        color: "var(--tera-yellow)",
      },
      {
        text: "La ubicación dentro de la platea se asigna por orden de llegada, sujeta a disponibilidad.",
        color: "var(--tera-cyan)",
      },
    ],
    bottomTaglineImage: todoResuelto,
    subSectors: [
      {
        name: "Platea Alta Norte A y B",
        titleImage: titPlateaAltaNorte,
        soldOut: true,
        bullets: [
          "Butaca individual",
          "Visual general",
          "Acceso a barras y gastronomía general",
          "Sanitarios generales",
        ],
        buyLink:
          "https://paseshow.com.ar/eventos/tera-un-millon-de-momentos-la-konga",
        wsLink: wsLinkFor("Platea Alta Norte A y B"),
        priceImage: price60milLote2,
      },
      {
        name: "Platea Baja Sur A",
        group: 1,
        titleImage: titPlateaBajaSurA,
        soldOut: true,
      },
      {
        name: "Platea Baja Sur B",
        group: 1,
        titleImage: titPlateaBajaSur,
        soldOut: true,
        bullets: [
          "Butaca individual",
          "Ubicación en platea baja",
          "Buena visual al escenario",
          "Acceso a barras y gastronomía general",
          "Sanitarios generales",
        ],
        buyLink:
          "https://paseshow.com.ar/eventos/tera-un-millon-de-momentos-la-konga",
        wsLink: wsLinkFor("Platea Baja Sur A y B"),
        priceImage: price80milLote2,
      },
      {
        name: "Platea Alta Oeste",
        titleImage: titPlateaAltaOeste,
        debajoTitle: lote1,
        bullets: [
          "Butaca individual",
          "Sector elevado",
          "Visual panorámica del espectáculo",
          "Acceso a barras y gastronomía general",
          "Sanitarios generales",
        ],
        buyLink:
          "https://paseshow.com.ar/eventos/tera-un-millon-de-momentos-la-konga",
        wsLink: wsLinkFor("Platea Alta Oeste"),
        priceImage: price60mil,
        priceHeightMobile: "50px",
        priceHeightDesktop: "60px",
      },
    ],
  },
  {
    key: "orbita-vr",
    name: "PLATEA",
    displayName: "PLATEA",
    subtitle: "VISIÓN REDUCIDA",
    entradaId: "EntradaPlateaVR",
    color: "var(--tera-pink)",
    tagColor: "#fff",
    tagShape: "circle",
    cardImageDesktop: cardPlateaVR,
    cardImageMobile: cardPlateaVRMobile,
    headline: "MISMA ENERGÍA, OTRA PERSPECTIVA.",
    legendImage: leyendaTop,
    legendLines: [
      {
        text: "Sector con asientos no numerados.",
        color: "var(--tera-yellow)",
      },
      {
        text: "La ubicación dentro de la platea se asigna por orden de llegada, sujeta a disponibilidad.",
        color: "var(--tera-cyan)",
      },
    ],
    sideTaglineImage: plateaFrase,
    subSectors: [
      {
        name: "VR Platea Alta Norte",
        titleImage: titVrPlateaAltaNorte,
        bullets: [
          "Butaca individual",
          "Ubicación en platea",
          "Visión parcial del escenario por elementos de la puesta",
          "Acceso a barras y gastronomía general",
          "Sanitarios generales",
        ],
        buyLink:
          "https://paseshow.com.ar/eventos/tera-un-millon-de-momentos-la-konga",
        wsLink: wsLinkFor("VR Platea Alta Norte"),
        priceImage: price25mil,
        priceHeightMobile: "50px",
        priceHeightDesktop: "60px",
      },
      {
        name: "VR Platea Baja Sur",
        titleImage: titVrPlateaBajaSur,
        bullets: [
          "Butaca individual",
          "Ubicación en platea",
          "Visión parcial del escenario por elementos de la puesta",
          "Acceso a barras y gastronomía general",
          "Sanitarios generales",
        ],
        buyLink:
          "https://paseshow.com.ar/eventos/tera-un-millon-de-momentos-la-konga",
        wsLink: wsLinkFor("VR Platea Baja Sur"),
        priceImage: price35mil,
        priceHeightMobile: "50px",
        priceHeightDesktop: "60px",
      },
    ],
  },
  //   {
  //     key: "infinito",
  //     name: "INFINITO",
  //     displayName: "PALCO PREFERENCIAL",
  //     titleImage: titPalcoPrefe,
  //     entradaId: "EntradaParking",
  //     color: "var(--tera-yellow)",
  //     tagColor: "var(--tera-cyan)",
  //     tagShape: "jagged",
  //     cardImageDesktop: cardPalcoPrefe,
  //     cardImageMobile: cardPalcoPrefeMobile,
  //     taglineImage: palcoPrefeFrase,
  //     headline: "LA MÁXIMA EXPRESIÓN DE TERA.",
  //     bullets: [
  //       "Palco exclusivo para grupo de personas",
  //       "2 estacionamientos incluidos",
  //       "Crédito para consumo de bebidas",
  //       "Ubicación preferencial",
  //       "Espacio exclusivo para el grupo",
  //       "Mozo asignado durante toda la jornada",
  //     ],
  //     tagline: "Una experiencia sin límites para vivir TERA con tu grupo, a otra escala.",
  //     buyLink: `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
  //       "Hola! Me gustaría recibir información para la compra de mesas en Infinito – TERA.",
  //     )}`,
  //     buyLabel: "Infinito",
  //     wsLink: wsLinkFor("Palco Preferencial"),
  //     vrVariant: {
  //       name: "VR Palco Preferencial",
  //       titleImage: titVrPalcoPrefe,
  //       buyLink: `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
  //         "Hola! Me gustaría recibir información para la compra de mesas en VR Palco Preferencial – TERA.",
  //       )}`,
  //       buyLabel: "VR Palco Preferencial",
  //       wsLink: wsLinkFor("VR Palco Preferencial"),
  //     },
  //   },
];

export function shareTera() {
  const url = window.location.origin + window.location.pathname;
  const text = "Vos con quién caés a TERA? 31 de octubre en Rafaela — activá tu TERA Pass.";

  if (navigator.share) {
    navigator.share({ title: "TERA", text, url }).catch(() => {});
    return;
  }

  const waText = `${text} ${url}`;
  window.open(
    `https://wa.me/?text=${encodeURIComponent(waText)}`,
    "_blank",
    "noopener,noreferrer",
  );
}

/**
 * "Hacé tu compra!" — cada tier/sub-sector/variante trae su propio buyLink
 * (y buyLabel para el tracking), así el link vive en un solo lugar (acá)
 * en vez de estar hardcodeado en cada página de entrada.
 */
export function buyTicket(link, label) {
  const isWhatsapp = link.includes("wa.me");
  if (window.fbq) {
    window.fbq("track", isWhatsapp ? "Contact" : "InitiateCheckout", {
      content_name: label,
      content_category: "Entradas TERA",
      destination: isWhatsapp ? "WhatsApp" : "Eden Entradas",
    });
  }
  window.open(link, "_blank", "noopener,noreferrer");
}

/**
 * "Pasale el dato a tu banda" — cada tier/sub-sector/variante trae su
 * propio wsLink con wording distinto (ver wsLinkFor arriba), separado del
 * buyLink (que va a Passline/Eden Entradas).
 */
export function contactWs(link, label) {
  if (window.fbq) {
    window.fbq("track", "Contact", {
      content_name: label,
      content_category: "Entradas TERA",
      destination: "WhatsApp",
    });
  }
  window.open(link, "_blank", "noopener,noreferrer");
}
